<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>

  <ng-container>
    <ng-container *ngIf="creatingAccountGroup$ | async; else createOpportunityButton">
      <button mat-stroked-button color="primary" class="card-button" disabled>
        <glxy-loading-spinner size="small"></glxy-loading-spinner>
      </button>
    </ng-container>
    <ng-container *ngIf="opportunities$ | async as opportunities; else loadingSpinner">
      <mat-card *ngFor="let opportunity of opportunities" appearance="outlined" class="association-card-contents">
        <mat-card-title>
          <a (click)="openOpportunityDetails(opportunity)">
            {{ opportunity.name }}
          </a>
        </mat-card-title>
        <mat-card-subtitle>
          {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.SUBTITLE.VALUE' | translate }}:
          {{ opportunity.value || 0 | formatCurrency: (currency$ | async) }}
          <br />
          {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.STAGE.TITLE' | translate }}:
          {{ opportunity.pipelineStage.name }}
          <br />
          {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.SUBTITLE.ACTIVITY' | translate }}:
          {{ opportunity.lastActivity !== null ? (opportunity.lastActivity | date: 'mediumDate') : '-' }}
          <br />
          {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.SUBTITLE.CLOSEDATE' | translate }}:
          {{ opportunity.expectedCloseDate !== null ? (opportunity.expectedCloseDate | date: 'mediumDate') : '-' }}
          <br />
          <div [ngSwitch]="opportunity.stage" class="status-badge">
            <glxy-badge *ngSwitchCase="'open'" color="blue">
              {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.STAGE.OPEN' | translate }}
            </glxy-badge>
            <glxy-badge *ngSwitchCase="'closed-won'" color="green">
              {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.STAGE.CLOSED_WON' | translate }}
            </glxy-badge>
            <glxy-badge *ngSwitchCase="'closed-lost'" color="red">
              {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.STAGE.CLOSED_LOST' | translate }}
            </glxy-badge>
          </div>
        </mat-card-subtitle>
      </mat-card>
      <button
        *ngIf="hasMoreOpportunities$$ | async"
        mat-stroked-button
        color="primary"
        class="card-button"
        type="button"
        (click)="viewMoreOpportunities()"
      >
        {{ 'COMMON.ACTION_LABELS.VIEW_MORE' | translate }}
      </button>
    </ng-container>
  </ng-container>
</mat-expansion-panel>

<ng-template #loadingSpinner>
  <glxy-loading-spinner id="spinner-container" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
</ng-template>
<ng-template #createOpportunityButton>
  <div
    [glxyTooltip]="'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.SALESPERSON_REQUIRED' | translate"
    [glxyTooltipDisabled]="(createBtnDisabled$ | async) === false"
  >
    <button
      mat-stroked-button
      class="card-button"
      color="primary"
      (click)="openCreateOpportunity()"
      [disabled]="createBtnDisabled$ | async"
    >
      {{ 'CRM.ASSOCIATION_PANEL.OPPORTUNITIES.ACTIONS.CREATE' | translate }}
    </button>
  </div>
</ng-template>
